import { useEffect, useState } from 'react';

/** The bundle this tab is running, from its own <script> tag. */
function runningBundle(): string | null {
  const src = [...document.scripts].map((s) => s.src).find((s) => /\/assets\/index-[^/]+\.js$/.test(s));
  return src ? src.slice(src.lastIndexOf('/') + 1) : null;
}

const CHECK_EVERY_MS = 3 * 60_000;

/**
 * Tells a long-open tab that a newer version has been deployed.
 *
 * A single-page app keeps running the code it loaded until reloaded, so a tab
 * left open across a deploy talks to the new server with old requests — which
 * the server then rejects. index.html is never cached, so comparing its bundle
 * name with ours is enough to notice.
 */
export function UpdateBanner() {
  const [stale, setStale] = useState(false);

  useEffect(() => {
    const mine = runningBundle();
    if (!mine) return; // dev server: no hashed bundle to compare
    let stopped = false;
    const check = async () => {
      try {
        const html = await fetch('/', { cache: 'no-store' }).then((r) => r.text());
        const live = /\/assets\/(index-[^"']+\.js)/.exec(html)?.[1];
        if (!stopped && live && live !== mine) setStale(true);
      } catch {
        // offline or mid-deploy: try again next time
      }
    };
    const timer = setInterval(check, CHECK_EVERY_MS);
    const onFocus = () => void check();
    window.addEventListener('focus', onFocus);
    return () => {
      stopped = true;
      clearInterval(timer);
      window.removeEventListener('focus', onFocus);
    };
  }, []);

  if (!stale) return null;
  return (
    <div className="update-banner" role="status">
      A new version of the CRM is available.
      <button className="btn btn-sm btn-primary" onClick={() => window.location.reload()}>Reload</button>
    </div>
  );
}
